import ThemedCapture from "@/components/marketing/ThemedCapture";

/* ────────────────────────────────────────────────────────────────────────────
 *  DossierFan — three real pages of the dossier, fanned.
 *
 *  Cover in front, Part II (Insights & Watchouts) and Part III (Property
 *  Profile, with the site plan and the WOZ trajectory) behind it — all three
 *  rasterised from the ONE PDF the capture session built from the PlotData
 *  the live cascade assembled (scripts/capture-product-sidebar.ts,
 *  renderReport), never from the fixture renders. Both looks exist because
 *  the dossier has a paper and a dark look of its own (§PDF dossier).
 * ──────────────────────────────────────────────────────────────────────────── */

export interface DossierPage {
  /** DARK render path; ThemedCapture derives the -light sibling. */
  src: string;
  alt: string;
  width: number;
  height: number;
}

export default function DossierFan({ pages }: { pages: [DossierPage, DossierPage, DossierPage] }) {
  const [cover, p2, p3] = pages;
  return (
    <div className="relative w-full max-w-[440px] mx-auto lg:mx-0 lg:max-w-[600px]" style={{ aspectRatio: "600 / 640" }}>
      {/* Behind: Part III, then Part II, each turned a few degrees so the
          stack reads as pages rather than a border. */}
      <Page page={p3} className="absolute left-[30%] top-[4%] w-[58%] rotate-[6deg] opacity-90" />
      <Page page={p2} className="absolute left-[4%] top-[2%] w-[58%] -rotate-[5deg] opacity-95" />
      <Page page={cover} className="absolute left-[17%] top-[10%] w-[64%]" front />
    </div>
  );
}

function Page({ page, className, front = false }: { page: DossierPage; className: string; front?: boolean }) {
  return (
    <figure
      className={`${className} rounded-lg border border-edge bg-surface p-1 ${
        front ? "shadow-[0_40px_90px_-30px_rgb(0_0_0/0.7)]" : "shadow-[0_20px_50px_-25px_rgb(0_0_0/0.6)]"
      }`}
      style={{ aspectRatio: `${page.width} / ${page.height}` }}
    >
      <ThemedCapture
        src={page.src}
        alt={page.alt}
        width={page.width}
        height={page.height}
        sizes="(min-width: 1024px) 320px, 70vw"
        loading="lazy"
        className="rounded-md w-full h-auto"
      />
    </figure>
  );
}
